'use strict';

/**
 * Append "list" method to given map. This methods returns a list of the enumerable properties of given map.
 * @param {Object} mapOfConstants Map containing 0 to N properties. Will have a new one called "list".
 * @returns {Object} Modified mapOfConstants
 */
function appendListMethod(mapOfConstants = {}) {
  if (!mapOfConstants.list) {
    Object.defineProperty(mapOfConstants, 'list', {
      enumerable: false,
      value: () => Object.keys(mapOfConstants).map(key => mapOfConstants[key]),
    });
  }

  return mapOfConstants;
}

module.exports = appendListMethod;
